import { render, staticRenderFns } from "./PopupSlidesComponent.vue?vue&type=template&id=9fcae75c&scoped=true&"
import script from "./PopupSlidesComponent.vue?vue&type=script&lang=js&"
export * from "./PopupSlidesComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopupSlidesComponent.vue?vue&type=style&index=0&id=9fcae75c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcae75c",
  null
  
)

export default component.exports